import React from 'react'
import PropTypes from 'prop-types'
import AppDropdown from 'Components/SearchFilterFactory/PanelForms/AppDropdown'
import { _SortBarContainer } from './styles'

const SortBar = ({
  sortType,
  sortTypeMap,
  sortTypeState,
  setSortTypeState,
  gaFromPage,
  isMobile = false,
  isMobileApp = false,
}) => (
  <_SortBarContainer>
    <AppDropdown
      label={`Sort : ${sortTypeState}`}
      blurBackground={false}
      gaFromPage={gaFromPage}
      gaFromComponent="PreconSort"
      selectedVal={sortTypeMap.find((e) => e.label === sortTypeState)?.value}
      onChange={(e) => setSortTypeState(sortType[e.value])}
      mobileFullPagePopup={isMobile || isMobileApp}
      isMobileApp={isMobileApp}
      options={sortTypeMap}
    />
  </_SortBarContainer>
)

SortBar.propTypes = {
  sortType: PropTypes.shape({
    priceLowToHigh: PropTypes.string,
    priceHighToLow: PropTypes.string,
    sizeLowToHigh: PropTypes.string,
    sizeHighToLow: PropTypes.string,
  }),
  sortTypeMap: PropTypes.arrayOf({}),
  sortTypeState: PropTypes.string,
  setSortTypeState: PropTypes.func,
  gaFromPage: PropTypes.string,
  isMobile: PropTypes.bool,
  isMobileApp: PropTypes.bool,
}

export default SortBar
